<template>
    <v-data-table
      :headers="headers"
      :items="listSpecialityFromRegister"
      height="auto"
      class="elevation-1"
      no-data-text="Sin resultados disponibles"
      fixed-header dense
      :footer-props="{
          'items-per-page-text': 'Elementos por página',
          'items-per-page-all-text': 'Todo',
          'items-per-page-options': [10],
        }"
    >
      <template v-slot:[`item.actions`]="{ index }">
        <v-tooltip v-if="isDelete" top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              class="mr-2"
              @click="deleteAppointment(index)"
              v-bind="attrs"
              v-on="on"
            >
              mdi mdi-delete
            </v-icon>
          </template>
          <span>Eliminar</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.guide`]="{ index }">
        <div>
          {{ index + 1 }}
        </div>
      </template>
      <template v-slot:[`item.idAppointment`]="{item }">
          {{ item.idStudy ||  item.idMedicalPractice }}
      </template>
      <template v-slot:[`item.selectTreatments`]="{ value }">
        <div v-for="(item, index) in value" :key="index">
          {{ item.text }}
        </div>
      </template>
      <template v-slot:[`item.status`]="{ item }">
        {{item.medicalPracticeStatusText || item.studyStatusText}}
      </template>
    </v-data-table>
  </template>
  
  <script>
  export default {
    props: {
      listSpecialityFromRegister: {
        type: Array,
      },
      deleteAppointment: Function,
    },
    data() {
      return {
        isDelete: true,
        headers: [
          { text: "#", value: "guide", align: "center" },
          { text: "Id consulta / id estudio", value: "idAppointment", align: "center"},
          { text: "Especialidad", value: "specialityName", align: "center" },
          { text: "Modalidad", value: "modalityFullName", align: "center" },
          { text: "Perfil de estudio", value: "studyProfileFullName", align: "center" },
          { text: "Estatus", value: "status", align: "center"}
        ],
      };
    },
  };
  </script>
  